module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAK1JREFUeNpiOHPmjAEDAcAExAJAhfPxKWIEEUBF+4HUByBONDEx+YDNJBBoBOIAIN4P1CCAVRFQ9wEgNQGIDbApZEJig0y7gE0hXBHULYlQt8EUGsAdjgygEiCPCMA8w4jNy1CF57G5CRnkI7EPMGExBRSwCVDuAqBbHZnQFPQjKSgEKkhEcThQAUgSFj2gkF+AHi0KSA51BCq4gC0w+3EpACuCetcBlwIQAAgwACVLQ8xfJC3ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/next.png
// module id = 268
// module chunks = 0